import React from "react";
import { NavLink } from "react-router-dom";
import { FiHome, FiUser, FiCalendar, FiPlusCircle, FiClock, FiFileText, FiGift } from "react-icons/fi";

const menu = [
  { name: "Dashboard", to: "/employee/dashboard", icon: <FiHome size={20}/> },
  { name: "My Profile", to: "/employee/profile", icon: <FiUser size={20}/> },
  { name: "My Leaves", to: "/employee/leaves", icon: <FiCalendar size={20}/> },
  { name: "Apply Leave", to: "/employee/apply-leave", icon: <FiPlusCircle size={20}/> },
  { name: "Attendance", to: "/employee/attendance", icon: <FiClock size={20}/> },
  { name: "Payslips", to: "/employee/payslips", icon: <FiFileText size={20}/> },
  { name: "Holidays", to: "/employee/holidays", icon: <FiGift size={20}/> },
  { name: "Timesheets", to: "/employee/timesheets", icon: <FiClock size={20}/> },
];

export default function EmpSidebar() {
  return (
    <aside className="w-64 bg-white border-r shadow-lg flex flex-col h-screen">
      {/* Logo / Title */}
      <div className="px-6 py-5 border-b">
        <h2 className="text-2xl font-bold text-gradient bg-gradient-to-r from-sky-500 to-indigo-500 bg-clip-text text-transparent">
          Company HR
        </h2>
        <p className="text-xs text-gray-400 mt-1">Employee Portal</p>
      </div>

      {/* Navigation */}
      <nav className="p-4 flex-1 space-y-2">
        {menu.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/employee"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all font-medium ${
                isActive
                  ? "bg-gradient-to-r from-sky-500 to-indigo-500 text-white shadow-lg"
                  : "text-gray-700 hover:bg-sky-50 hover:text-sky-600"
              }`
            }
          >
            <div className="flex-shrink-0">{item.icon}</div>
            <span>{item.name}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="px-6 py-4 mt-auto border-t">
        <div className="text-xs text-gray-500">Need help?</div>
        <a href="#" className="text-sky-600 font-medium text-sm hover:underline">
          Contact HR
        </a>
      </div>
    </aside>
  );
}
